<template>
    <div>
        <template v-if="crud_department === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Departments</h1>
                <router-link to="/addDepartment" class="btn btn-primary float-right active"> Add New Department</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" autocomplete="off" />
                </div>
            </div>
            <table id="departmentTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Department</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="crud_department === null"><preLoader></preLoader></template>
        <template v-if="crud_department === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_department : null,
            };
        },
        methods: {
            getDepartments(){
                var departmentTable = $('#departmentTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listDepartments",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editDepartment/'+full['id'];
                            var $url_delete = '/deleteDepartment/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    departmentTable.search(this.value).draw();
                });
            },
          softDelete(departmentId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/departmentSoftDelete", {DepartmentID: departmentId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Department deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        },
        mounted() {
         var gThat = this;
            this.$Progress.start();
            this.can('crud_department').then(result=>{
                this.crud_department = result.crud_department;
            }).then(result=>{
                this.getDepartments();
            });
          window.softDelete = function(departmentId){
            gThat.softDelete(departmentId);
          }
        },
        created() {
            // 
        }        
    }
</script>
